<template>
  <div class="user-log-page">
    <!-- App switch tab -->
    <div class="app-tabs">
      <span class="app-tab" :class="{ active: currentApp === 'finova' }" @click="switchApp('finova')"> Finova </span>
      <span class="app-tab" :class="{ active: currentApp === 'invest' }" @click="switchApp('invest')">
        Finova Invest
      </span>
    </div>

    <!-- Search form area -->
    <div class="search-form">
      <a-form :form="form" layout="inline">
        <a-form-item :label="$t('custTrans.userMobile')">
          <a-input v-decorator="['mobile']" :placeholder="$t('custTrans.userMobile')" style="width: 200px" />
        </a-form-item>
        <a-form-item :label="$t('custTrans.queryTime')">
          <a-range-picker v-decorator="['dateRange']" format="DD-MM-YYYY">
            <a-icon slot="suffixIcon" type="calendar" />
          </a-range-picker>
        </a-form-item>
        <a-form-item>
          <a-button @click="handleReset">{{ $t('platformCollection.reset') }}</a-button>
          <a-button type="primary" @click="handleSearch" :loading="loading" style="margin-left: 8px">
            {{ $t('search') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>

    <!-- Table area -->
    <div class="table-wrapper">
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="false"
        :row-key="(record, index) => index"
        :expanded-row-keys="expandedRowKeys"
        :expand-icon="() => null"
        size="small"
      >
        <!-- Phone column -->
        <template slot="mobile" slot-scope="text, record">
          {{ record.process_mobile || text }}
        </template>

        <!-- Operation/Event column -->
        <template slot="operate" slot-scope="text, record">
          {{ record.process_operate || record.operate || text }}
        </template>

        <!-- Occurrence time column -->
        <template slot="timestamp" slot-scope="text">
          {{ text ? transformTime(text, 2) : '' }}
        </template>

        <!-- Output param/Input param column -->
        <template slot="params" slot-scope="text, record, index">
          <a @click="toggleExpand(index)" :style="{ cursor: 'pointer', color: '#1890ff' }">
            {{ expandedRowKeys.includes(index) ? $t('custTrans.collapse') : $t('custTrans.expand') }}
          </a>
        </template>

        <!-- Expanded row -->
        <template slot="expandedRowRender" slot-scope="record">
          <div class="log-detail">
            <pre>{{ record.raw_line || record.content || '' }}</pre>
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { getUserLog } from '@/webpublicapi/system'
import { updateSearch } from '@/webpublicapi/vietnamBackstage'
import { transformTime } from '@/components/_util/util'
import moment from 'moment'

export default {
  name: 'UserLog',
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      dataSource: [],
      expandedRowKeys: [],
      currentApp: 'finova',
      columns: [
        {
          title: this.$t('phoneNo'),
          dataIndex: 'mobile',
          key: 'mobile',
          width: '25%',
          scopedSlots: { customRender: 'mobile' },
        },
        {
          title: this.$t('custTrans.action'),
          dataIndex: 'operate',
          key: 'operate',
          width: '25%',
          scopedSlots: { customRender: 'operate' },
        },
        {
          title: this.$t('custTrans.happenTime'),
          dataIndex: 'timestamp',
          key: 'timestamp',
          width: '25%',
          scopedSlots: { customRender: 'timestamp' },
        },
        {
          title: this.$t('custTrans.outParamInParam'),
          dataIndex: 'params',
          key: 'params',
          width: '25%',
          scopedSlots: { customRender: 'params' },
        },
      ],
    }
  },
  created() {
    // Do not auto-query on page load, wait for user to click search button
  },
  methods: {
    loadData() {
      this.loading = true
      const values = this.form.getFieldsValue()
      const parameter = {}

      // Process phone number params
      if (values.mobile) {
        parameter.mobile = values.mobile
      }

      // Process time range params
      if (values.dateRange && values.dateRange.length === 2) {
        parameter.begin = values.dateRange[0].format('YYYY-MM-DD')
        parameter.end = values.dateRange[1].format('YYYY-MM-DD')
      }

      // Select different API based on current app
      const api = this.currentApp === 'invest' ? updateSearch : getUserLog

      api(parameter)
        .then((response) => {
          // Check response status
          if (response.success || response.code === 200 || response.respCode === 1000) {
            // Process response data based on API type
            if (this.currentApp === 'invest') {
              // updateSearch API usage respData Field
              this.dataSource = response.respData || []
            } else {
              // getUserLog API usage data Field
              if (response.data) {
                this.dataSource = response.data.records || response.data.list || response.data
              } else {
                this.dataSource = response.records || response.list || []
              }
            }
          } else {
            // API returns business error
            this.$message.error(response.respMsg || response.msg)
            this.dataSource = []
          }
        })
        .catch((error) => {
          this.$message.error('thất bại')
          this.dataSource = []
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleSearch() {
      this.loadData()
    },

    handleReset() {
      this.form.resetFields()
      this.dataSource = []
      this.expandedRowKeys = []
    },

    switchApp(app) {
      if (this.currentApp === app) return
      this.currentApp = app
      // Clear form, data and expanded state when switching apps
      this.form.resetFields()
      this.dataSource = []
      this.expandedRowKeys = []
    },

    toggleExpand(index) {
      const keys = [...this.expandedRowKeys]
      const idx = keys.indexOf(index)
      if (idx > -1) {
        keys.splice(idx, 1)
      } else {
        keys.push(index)
      }
      this.expandedRowKeys = keys
    },
  },
}
</script>

<style scoped>
.user-log-page {
  padding: 20px;
  background: #fff;
}

.user-log-page .app-tabs {
  margin-bottom: 16px;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 0;
}

.user-log-page .app-tab {
  display: inline-block;
  padding: 12px 24px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  position: relative;
  transition: all 0.3s;
}

.user-log-page .app-tab:hover {
  color: #1890ff;
}

.user-log-page .app-tab.active {
  color: #1890ff;
  font-weight: 500;
}

.user-log-page .app-tab.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: #1890ff;
}

.user-log-page .search-form {
  margin-bottom: 20px;
  padding: 16px;
  /* background: #fafafa; */
  border-radius: 4px;
}

.user-log-page .search-form >>> .ant-form-item {
  margin-bottom: 0;
  margin-right: 16px;
}

.user-log-page .table-wrapper >>> .ant-table {
  font-size: 13px;
}

.user-log-page .table-wrapper >>> .ant-table-thead > tr > th {
  background: #f0f5ff;
  font-weight: 500;
}

.user-log-page .log-detail {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  margin: 8px 0;
  width: 100%;
  box-sizing: border-box;
}

.user-log-page .log-detail pre {
  margin: 0;
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  word-break: break-all !important;
  max-width: 100%;
  width: 100%;
  font-size: 12px;
  line-height: 1.5;
  color: #333;
}

/* Cover ant-design-vue Default style for table expanded rows */
.user-log-page .table-wrapper >>> .ant-table-expanded-row > td {
  padding: 0 !important;
}

.user-log-page .table-wrapper >>> .ant-table-expanded-row td {
  word-wrap: break-word !important;
  word-break: break-all !important;
  white-space: normal !important;
}
</style>
